import { render, staticRenderFns } from "./HappyHolidaysTop.vue?vue&type=template&id=460ebca3&scoped=true&"
import script from "./HappyHolidaysTop.vue?vue&type=script&lang=js&"
export * from "./HappyHolidaysTop.vue?vue&type=script&lang=js&"
import style0 from "./HappyHolidaysTop.vue?vue&type=style&index=0&id=460ebca3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ebca3",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports